import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { classNames } from "primereact/utils";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PrimeDialog from "../../components/dialog/PrimeDialog";
import { FormInput } from "../../components/FormInput";
import { FormInputFile } from "../../components/FormInputFile";
import FormNumberInput from "../../components/FormNumberInput";
import { FormTextarea } from "../../components/FormTextarea";
import ImagePDFComponent from "../../components/ImagePDFComponent";
import { MaskedFormInput } from "../../components/MaskedFormInput";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { useFuncId } from "../../router/menuRouterMapper";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import { AlertService } from "../../utility/service/alert-service";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { updateAuditEyesEvent } from "../../utility/service/audilog-service";
import {
  F1010311Before,
  createOrgCriterion,
  getCompanyPlaceList,
  queryCountyList,
  updatePlaces,
} from "../../utility/service/carbon-service";
import {
  Base64Encoder,
  BcryptEncoder,
  checkDpSuccess,
  getCompanyType,
  getFileBase64,
  getFormErrorMessage,
  getLocale,
  splitFileExtension,
  splitFileName,
} from "../../utility/service/tool-service";
import { addFormValidator } from "../../utility/validate/formValidator";
import { set } from "bignumber.js";

const PlaceMaintain = () => {
  const { t } = useTranslation();
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const chsFuncId = useFuncId();
  const [placeSetting, setPlaceSetting] = useState("addPlace");
  const [formRule, setFormRule] = useState([]); //表單驗證
  const [action, setAction] = useState("create");
  const [maskView, setMaskView] = useState(true);
  const [createFlag, setCreateFlag] = useState(false);
  const [createLimitDialog, setCreateLimitDialog] = useState(false);

  // 下拉選單
  const [companyPlaceList, setCompanyPlaceList] = useState([]); // 組織
  const [placeList, setPlaceList] = useState([]); // 場所
  const [ruleList, setRuleList] = useState([]); //邊界設定方法
  const [bussinessAuthList, setBussinessAuthList] = useState([]);
  const [missionReasonList, setMissionReasonList] = useState([]);
  const [countyList, setCountyList] = useState([]);

  // 附件
  const areaFileInputRef = useRef(null);
  const [areaFileInfo, setAreaFileInfo] = useState({});
  const layoutFileRef = useRef(null);
  const [layoutFileInfo, setLayoutFileInfo] = useState({});

  const {
    getValues,
    setValue,
    watch,
    reset,
    control,
    register,
    trigger,
    handleSubmit,
    clearErrors,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {},
    //錯誤驗證時機
    mode: "all",
  });

  const isEditable = useEditableFlag("F10402") && watch("companySeq"); // Get editable status for F10402 function

  useEffect(() => {
    axios_getSubItemsByItemNo("CFV_AREA_RULE", 5).then(setRuleList);
    axios_getSubItemsByItemNo("BUSINESS_AUTHORITIES", 47).then(setBussinessAuthList);
    axios_getSubItemsByItemNo("MISSING_REASON", 51).then(setMissionReasonList);
    axios_queryCountyList();
    axios_getCompanyPlaceList();
    axios_getCreateBefore();
  }, []);

  const axios_getSubItemsByItemNo = (itemNo, orderNo) => {
    return getSubItemsByItemNo(itemNo, orderNo).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        return data.map((item, index) => ({
          ...item,
          index,
        }));
      }
      return [];
    });
  };

  // 組織邊界廠商清單
  const axios_getCompanyPlaceList = (callback) => {
    checkLoading(loading);
    getCompanyPlaceList()
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res.data.RespBody.companyPlaceList;
          setCompanyPlaceList(data);
          if (getCompanyType() === "A") {
            setValue("companySeq", data[0].companySeq);
            handleCompanyChange(data[0].placeList, data[0].createButtonFlag);
          }
          callback?.(data);
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  // 組織變動處理
  const handleCompanyChange = (placeList, createFlag) => {
    setCreateFlag(createFlag);
    setPlaceList(placeList);
    if (!createFlag) {
      setPlaceSetting("place");
      setAction("detail");
    }
  };

  // 查詢地區代碼
  const axios_queryCountyList = () => {
    queryCountyList().then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.countyList;
        setCountyList(data);
      }
    });
  };

  // 建立前查詢form 規則
  const axios_getCreateBefore = () => {
    F1010311Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule],
  );

  const zipCodeSeqTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>
            {option?.district}({option?.zipcode})
          </div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  //刪除圖片
  const handleDeleteImg = (pic) => {
    if (pic === "areaPic") {
      if (areaFileInputRef?.current?.value !== undefined) {
        areaFileInputRef.current.value = null;
        setAreaFileInfo((pre) => {
          return {
            ...pre,
            filePathSml: "",
            filePath: "",
            fileInfo: {},
          };
        });
        setValue("areaPic", "", { shouldValidate: true, shouldDirty: true });
        setValue("fileName", "");
        setValue("fileExtension", ""); //副檔名
      }
    } else if (pic === "layoutPic") {
      if (layoutFileRef?.current?.value !== undefined) {
        layoutFileRef.current.value = null;
        setLayoutFileInfo((pre) => {
          return {
            ...pre,
            filePathSml: "",
            filePath: "",
            fileInfo: {},
          };
        });
        setValue("layoutPic", "", { shouldValidate: true, shouldDirty: true });
        setValue("layoutFileName", "");
        setValue("layoutFileExtension", ""); //副檔名
      }
    }
  };

  //每次開啟選擇檔案觸發onChange事件
  const handleFileChange = (e, pic) => {
    if (e.target.files[0]) {
      if (e.target.files[0].size >= 5000000) {
        //大於5MB
        AlertService.ok("Error", "Size over 5MB");
        if (pic === "areaPic") {
          setValue("fileExtension", ""); //副檔名
          setValue("fileName", "");
          setValue("areaPic", "");
          areaFileInputRef.current.value = null;
        } else if (pic === "layoutPic") {
          setValue("layoutFileExtension", ""); //副檔名
          setValue("layoutFileName", "");
          setValue("layoutPic", "");
          layoutFileRef.current.value = null;
        }
      } else {
        let fileExtension = splitFileExtension(e.target.files[0]?.name);
        if (pic === "areaPic") {
          setAreaFileInfo({
            filePathSml: URL.createObjectURL(e.target.files[0]),
            filePath: URL.createObjectURL(e.target.files[0]),
            fileInfo: {
              type: fileExtension,
              name: splitFileName(e.target.files[0]?.name),
            },
          });
          setValue("areaPic", e.target.files[0], { shouldValidate: true, shouldDirty: true });
          setValue("fileExtension", fileExtension); //副檔名
          setValue("fileName", splitFileName(e.target.files[0]?.name));
          getFileBase64(e.target.files[0]).then((result) => {
            setValue("areaPic", result);
          });
        } else if (pic === "layoutPic") {
          setLayoutFileInfo({
            filePathSml: URL.createObjectURL(e.target.files[0]),
            filePath: URL.createObjectURL(e.target.files[0]),
            fileInfo: {
              type: fileExtension,
              name: splitFileName(e.target.files[0]?.name),
            },
          });
          setValue("layoutPic", e.target.files[0], { shouldValidate: true, shouldDirty: true });
          setValue("layoutFileExtension", fileExtension); //副檔名
          setValue("layoutFileName", splitFileName(e.target.files[0]?.name));
          getFileBase64(e.target.files[0]).then((result) => {
            setValue("layoutPic", result);
          });
        }
      }
    }
  };

  // 處理選擇場所邏輯
  const handlePlaceChange = (placeSeq, externalList) => {
    const source = externalList ?? placeList;
    const placeData = source?.find((item) => item.placeSeq === placeSeq);
    reset({
      ...placeData,
      areaAddress: getLocale() === "ZH-TW" && placeData?.zipcodeSeq ? "domestic" : "overseas",
      areaPic: placeData?.filePath,
      place: placeData?.placeSeq,
      companySeq: getValues("companySeq"),
      layoutPic: placeData?.layoutFilePath,
    });

    setAreaFileInfo({
      fileInfo: {
        type: placeData?.fileExtension,
        name: placeData?.fileName,
      },
      filePathSml: placeData?.filePathSml,
      filePath: placeData?.filePath,
    });
    setLayoutFileInfo({
      fileInfo: {
        type: placeData?.layoutFileExtension,
        name: placeData?.layoutFileName,
      },
      filePathSml: placeData?.layoutFilePathSml,
      filePath: placeData?.layoutFilePath,
    });
  };

  // 遮罩
  const handleMaskClick = () => {
    setMaskView((prev) => {
      return !prev;
    });
  };

  // 遮罩 audit
  const axios_updateAuditEyesEvent = () => {
    updateAuditEyesEvent({
      functionId: chsFuncId,
      eventType: "E",
    }).then((res) => {
      if (checkDpSuccess(res)) {
      }
    });
  };

  // 編碼
  const encoder = (dataList, code) => {
    const findItemIndex = (map, code) => {
      return map.get(code) ?? false;
    };
    if (!isNotBlank(code)) return null;
    if (!isNotBlank(dataList === null) || dataList.length <= 0) return null;
    return Base64Encoder(BcryptEncoder(code)) + "," + findItemIndex(dataList, code);
  };

  // 重設表單
  const resetFormData = (data) => {
    const allFields = getValues();
    const clearedValues = Object.keys(allFields).reduce((acc, key) => {
      acc[key] = null;
      return acc;
    }, {});
    reset({
      ...clearedValues,
      ...data,
    });
    clearErrors();
    setAreaFileInfo({});
    setLayoutFileInfo({});
    if (areaFileInputRef.current) {
      areaFileInputRef.current.value = null;
    }
    if (layoutFileRef.current) {
      layoutFileRef.current.value = null;
    }
  };

  const isNotBlank = (value) => {
    return value !== undefined && value != null && value !== "";
  };

  const onSubmit = (data) => {
    const formData = new FormData();

    if (getLocale() === "ZH-TW" && data.areaAddress === "domestic") {
      formData.append("zipcodeSeq", data.zipcodeSeq !== undefined && data.zipcodeSeq !== "" ? data.zipcodeSeq : null); //沒有值給null 只有locale 為ZH-TW 才顯示
    }

    const ruleMap = new Map(ruleList.map((v, i) => [v.subitemNo, v.index]));
    const missionReasonMap = new Map(missionReasonList.map((v, i) => [v.subitemNo, v.index]));
    const bussinessAuthMap = new Map(bussinessAuthList.map((v, i) => [v.subitemNo, v.index]));

    const reqBody = {
      companySeq: data.companySeq,
      name: placeSetting === "addPlace" ? data.name : data.placeName,
      placeSeq: placeSetting === "addPlace" ? null : data.placeSeq,
      address: data.address,
      headcount: data.headcount,
      registrationNo: data.registrationNo,
      facRegNo: data.facRegNo,
      contactName: data.contactName,
      contactEmail: data.contactEmail,
      ratio: data.rule === "1" ? data.ratio : null,
      contactTel: data.contactTel,
      contactMobile: data.contactMobile,
      siteArea: data.siteArea,
      rule: encoder(ruleMap, data.rule),
      placeNo: data.placeNo,
      taxIdNum: data.taxIdNum,
      customerNo: data.customerNo,
      customerNoMissingReason: encoder(missionReasonMap, data.customerNoMissingReason),
      customerNoMissingRemark: data.customerNoMissingRemark,
      isSharedMeter: data.isSharedMeter,
      remark: data.remark,
      certificateNumber: data.certificateNumber,
      competentAuthorityId: encoder(bussinessAuthMap, data.competentAuthorityId),
    };
    Object.entries(reqBody).forEach(([key, value]) => {
      if (isNotBlank(value)) {
        formData.append(key, value);
      }
    });

    const areaFile = areaFileInputRef.current?.files[0];
    const layoutFile = layoutFileRef.current?.files[0];

    if (placeSetting === "addPlace") {
      checkLoading(loading);

      if (isNotBlank(areaFile)) {
        formData.append("areaPic", areaFile);
        formData.append("fileName", data.fileName);
        formData.append("fileExtension", data.fileExtension);
      }

      if (isNotBlank(layoutFile)) {
        formData.append("layoutPic", layoutFile);
        formData.append("layoutFileName", data.layoutFileName);
        formData.append("layoutFileExtension", data.layoutFileExtension);
      }

      createOrgCriterion(formData)
        .then((res) => {
          if (checkDpSuccess(res)) {
            setAction("create");
            setPlaceSetting("addPlace");
            // 重新查詢組織邊界清單
            axios_getCompanyPlaceList();
            handleSuccessMessage(dispatch, t("button.create") + " " + t("message.success"));
            resetFormData({
              companySeq: data.companySeq,
            });
          }
        })
        .finally((fin) => {
          checkLoading(loading, false);
          if (!createFlag) {
            setCreateLimitDialog(true);
          }
        });
    } else if (placeSetting === "place") {
      checkLoading(loading);

      if (isNotBlank(data.fileId) && isNotBlank(areaFile)) {
        //更新
        formData.append("fileId", data.fileId);
        formData.append("areaPic", areaFile);
        formData.append("fileName", data.fileName);
        formData.append("fileExtension", data.fileExtension);
      }

      if (!isNotBlank(data.layoutFileId) && isNotBlank(layoutFile)) {
        //新增
        formData.append("layoutPic", layoutFile);
        formData.append("layoutFileName", data.layoutFileName);
        formData.append("layoutFileExtension", data.layoutFileExtension);
      } else if (isNotBlank(data.layoutFileId) && isNotBlank(layoutFile)) {
        //更新
        formData.append("layoutFileId", data.layoutFileId);
        formData.append("layoutPic", layoutFile);
        formData.append("layoutFileName", data.layoutFileName);
        formData.append("layoutFileExtension", data.layoutFileExtension);
      } else if (isNotBlank(data.layoutFileId) && !isNotBlank(data.layoutPic)) {
        //刪除
        formData.append("layoutFileId", data.layoutFileId);
      }

      updatePlaces(formData)
        .then((res) => {
          if (checkDpSuccess(res)) {
            const currentPlaceSeq = data.placeSeq;
            const currentCompanySeq = data.companySeq;
            axios_getCompanyPlaceList((companyData) => {
              const company = companyData?.find((item) => item.companySeq === currentCompanySeq);
              handleCompanyChange(company?.placeList, company?.createButtonFlag);
              handlePlaceChange(currentPlaceSeq, company?.placeList);
            });
            setAction("detail");
            setMaskView(false);
            handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
          }
        })
        .finally((fin) => {
          checkLoading(loading, false);
        });
    }
  };

  const checkKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  return (
    <>
      <div className="p-card">
        <div className="p-card-body">
          <form onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown} className="grid">
            {/* 組織名稱 */}
            <div className="col-12 lg:col-4">
              <label htmlFor="placeName" className="form-label required">
                {t("organName")}
              </label>
              <Controller
                name="companySeq"
                control={control}
                rules={{ required: { value: true, message: t("validation.required") } }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    disabled={getCompanyType() === "A"}
                    appendTo={"self"}
                    optionLabel="companyName"
                    optionValue="companySeq"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="companySeq"
                    control={control}
                    options={companyPlaceList ?? []}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                      const data = companyPlaceList?.find((item) => item.companySeq === event.value);
                      resetFormData({
                        companySeq: event.value,
                      });
                      handleCompanyChange(data?.placeList, data?.createButtonFlag);
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, "companySeq")}
            </div>
            {/* 場所 */}
            <div className="col-12">
              <label htmlFor="name" className={`form-label ${action === "detail" ? "" : "required"}`}>
                {t("place")}
              </label>
              {/* 新增場所 */}
              <div className="col-12 flex align-items-center gap-2">
                <RadioButton
                  inputId="addPlace"
                  disabled={!createFlag || !isEditable}
                  name="addPlace"
                  value="addPlace"
                  onChange={(e) => {
                    setPlaceSetting(e.value);
                    setMaskView(true);
                    resetFormData({ companySeq: getValues("companySeq") });
                    setAction("create");
                  }}
                  checked={placeSetting === "addPlace"}
                />
                <label htmlFor="addPlace">{t("add_place")}</label>
                {/* 場所數量已達上限 */}
                {!createFlag && watch("companySeq") && <small className="text-red-600">{t("placeLimitReached")}</small>}
              </div>
              {/* 既有場所 */}
              <div className="col-12 flex align-items-center gap-2">
                <RadioButton
                  inputId="place"
                  name="place"
                  value="place"
                  disabled={!isEditable}
                  onChange={(e) => {
                    setPlaceSetting(e.value);
                    axios_getCompanyPlaceList();
                    setAction("detail");
                    setMaskView(false);
                  }}
                  checked={placeSetting === "place"}
                />
                <label htmlFor="place">{t("has_place")}</label>
                {placeSetting === "place" && (
                  <div className="flex-1">
                    <Controller
                      name="place"
                      control={control}
                      rules={setValidForm("place")}
                      render={({ field, fieldState }) => (
                        <Dropdown
                          disabled={watch("companySeq") === ""}
                          appendTo={"self"}
                          optionLabel="placeName"
                          optionValue="placeSeq"
                          value={field.value}
                          virtualScrollerOptions={{ itemSize: 40 }}
                          defaultValue={""}
                          placeholder={t("plz_chs")}
                          name="place"
                          control={control}
                          options={placeList}
                          className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                          onChange={(event) => {
                            field.onChange(event.value);
                            setPlaceList(
                              companyPlaceList?.find((item) => item.companySeq === watch("companySeq"))?.placeList,
                            );
                            handlePlaceChange(event.value);
                          }}
                        />
                      )}
                    />
                  </div>
                )}
              </div>
            </div>
            {/* 場所名稱 */}
            <div className="col-12 lg:col-6 mb-5">
              {placeSetting === "addPlace" && (
                <FormInput
                  labelClass={`form-label ${action === "detail" ? "" : "required"}`}
                  register={register}
                  labelText={t("place_name")}
                  errors={errors}
                  id="name"
                  name="name"
                  type="text"
                  disabled={!isEditable}
                  rules={setValidForm("name")}
                  wrapperStyle={{ height: 48 + "px" }}
                />
              )}
              {placeSetting === "place" && (
                <FormInput
                  labelClass={`form-label ${action === "detail" ? "" : "required"}`}
                  register={register}
                  labelText={t("place_name")}
                  errors={errors}
                  id="placeName"
                  name="placeName"
                  type="text"
                  disabled={placeSetting === "place" && action === "detail"}
                  rules={setValidForm("name")}
                  wrapperStyle={{ height: 48 + "px" }}
                />
              )}
            </div>
            {/* 設定方法 */}
            <div className="col-12">
              <label htmlFor="rule" className={`form-label ${action === "detail" ? "" : "required"}`}>
                {t("boundary_setting")}
              </label>
              <div className="flex flex-wrap gap-3">
                <Controller
                  name="rule"
                  control={control}
                  rules={{ required: "Value is required." }}
                  render={({ field }) => (
                    <>
                      {ruleList?.map((item) => {
                        return (
                          <div className="flex align-items-center" key={item.subitemNo}>
                            <RadioButton
                              inputId={`rule${item.subitemNo}`}
                              {...field}
                              inputRef={field.ref}
                              value={item.subitemNo}
                              disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                              checked={field.value === item.subitemNo}
                            />
                            <label htmlFor={`rule${item.subitemNo}`} className="ml-2">
                              {item.subitemName}
                            </label>
                          </div>
                        );
                      })}
                    </>
                  )}
                />
              </div>
            </div>
            {/* 股權比例 */}
            {watch("rule") === "1" && (
              // 股權比例
              <div className="col-12 lg:col-4">
                <FormNumberInput
                  register={register}
                  errors={errors}
                  id="ratio"
                  name="ratio"
                  rules={{
                    validate: (value) => {
                      if (watch("rule") === "1" && (!value || value.toString().trim() === "")) {
                        return t("validation.required");
                      }
                      return true;
                    },
                  }}
                  labelText={`${t("shareholding_ratio")} %`}
                  labelClass={`${action === "detail" ? "" : "required"}`}
                  disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                  value={watch("ratio")}
                  onChange={(newValue) => setValue("ratio", newValue)}
                />
              </div>
            )}
            {/* 地址 */}
            <div className="col-12">
              <label htmlFor="countyCode" className={`form-label ${action === "detail" ? "" : "required"}`}>
                {t("address")}
              </label>
              {/* 國內/國外切換選單 */}
              {getLocale() === "ZH-TW" && (
                <div className="flex flex-wrap gap-3 mb-2">
                  <Controller
                    name="areaAddress"
                    control={control}
                    rules={{ required: "Value is required." }}
                    render={({ field }) => (
                      <div className="flex align-items-center">
                        <RadioButton
                          inputId="domestic"
                          {...field}
                          inputRef={field.ref}
                          value="domestic"
                          disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                          checked={field.value === "domestic"}
                        />
                        <label htmlFor="domestic" className="mx-2">
                          {t("domestic")}
                        </label>
                        <RadioButton
                          inputId="overseas"
                          {...field}
                          inputRef={field.ref}
                          value="overseas"
                          disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                          checked={field.value === "overseas"}
                        />
                        <label htmlFor="overseas" className="mx-2">
                          {t("overseas")}
                        </label>
                      </div>
                    )}
                  />
                </div>
              )}

              <div className="flex align-items-start gap-2 flex-wrap lg:flex-nowrap">
                {/* 中文(台灣) 出現國內國外選項 */}
                {(getLocale() === "ZH-TW" && watch("areaAddress")) === "domestic" && (
                  <>
                    <Controller
                      name="countyCode"
                      control={control}
                      rules={{
                        required: { value: true, message: t("validation.required") },
                      }}
                      render={({ field, fieldState }) => (
                        <Dropdown
                          filter
                          disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                          appendTo={"self"}
                          optionLabel="countyName"
                          optionValue="countyCode"
                          value={field.value}
                          virtualScrollerOptions={{ itemSize: 40 }}
                          defaultValue={""}
                          placeholder={t("plz_chs")}
                          name="countyCode"
                          control={control}
                          options={countyList}
                          className={`lg:w-3 w-full ` + classNames({ "p-invalid": fieldState.error })}
                          onChange={(event) => {
                            field.onChange(event.value);
                            setValue("zipcodeSeq", "");
                          }}
                        />
                      )}
                    />
                    <Controller
                      name="zipcodeSeq"
                      control={control}
                      rules={setValidForm("zipcodeSeq")}
                      render={({ field, fieldState }) => (
                        <Dropdown
                          filter
                          filterBy="district,zipcode"
                          disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                          appendTo={"self"}
                          optionLabel="district"
                          itemTemplate={zipCodeSeqTemplate}
                          valueTemplate={zipCodeSeqTemplate}
                          optionValue="zipcodeSeq"
                          value={field.value}
                          virtualScrollerOptions={{ itemSize: 40 }}
                          defaultValue={""}
                          placeholder={t("plz_chs")}
                          name="zipcodeSeq"
                          control={control}
                          options={
                            countyList?.find((item) => item.countyCode === watch("countyCode"))?.districList ?? []
                          }
                          className={`lg:w-3 w-full ` + classNames({ "p-invalid": fieldState.error })}
                          onChange={(event) => {
                            field.onChange(event.value);
                          }}
                        />
                      )}
                    />
                  </>
                )}
                <FormInput
                  disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                  wrapperClass={`${
                    getLocale() === "ZH-TW" && watch("areaAddress") === "domestic" ? "lg:w-6 w-full" : "w-full"
                  }`}
                  register={register}
                  placeholder={t("validation.address")}
                  errors={errors}
                  id="address"
                  name="address"
                  type="text"
                  rules={setValidForm("address")}
                />
              </div>
            </div>
            {/* 分據點編號 */}
            <div className="col-12 lg:col-4">
              <FormInput
                register={register}
                errors={errors}
                id="placeNo"
                name="placeNo"
                labelText={`${t("placeNo")}`}
                placeholder={t("placeNoHint")}
                rules={setValidForm("placeNo")}
                disabled={(placeSetting === "place" && action === "detail") || !isEditable}
              />
            </div>
            {/* 管制編號 */}
            <div className="col-12 lg:col-4">
              <FormInput
                register={register}
                errors={errors}
                labelClass={`form-label`}
                id="registrationNo"
                name="registrationNo"
                type="text"
                /*placeholder={t('validation.stringanumLen',{len:10})}*/
                labelText={`${t("control_no")}`}
                disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                rules={setValidForm("registrationNo")}
              />
            </div>
            {/* 工廠登記證編號 */}
            <div className="col-12 lg:col-4">
              <FormInput
                register={register}
                errors={errors}
                id="facRegNo"
                name="facRegNo"
                type="text"
                /*placeholder={t('validation.stringanumLen',{len:10})}*/
                labelText={`${t("factory_registration_no")}`}
                rules={setValidForm("facRegNo")}
                disabled={(placeSetting === "place" && action === "detail") || !isEditable}
              />
            </div>
            {/* 事業主管機關編號 */}
            <div className="col-12 lg:col-4">
              <label htmlFor="competentAuthorityId" className="form-label">
                {t("competentAuthorityId")}
              </label>
              <Controller
                name="competentAuthorityId"
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    showClear
                    disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                    appendTo={"self"}
                    optionLabel="subitemName"
                    optionValue="subitemNo"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="competentAuthorityId"
                    control={control}
                    options={bussinessAuthList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, "competentAuthorityId")}
            </div>
            {/* 主管機關核發證書字號 */}
            <div className="col-12 lg:col-4">
              <FormInput
                register={register}
                errors={errors}
                id="certificateNumber"
                name="certificateNumber"
                labelText={`${t("certificateNumber")}`}
                rules={setValidForm("certificateNumber")}
                disabled={(placeSetting === "place" && action === "detail") || !isEditable}
              />
            </div>
            {/* 場所面積 */}
            <div className="col-12 lg:col-4">
              <FormInput
                register={register}
                errors={errors}
                labelClass="form-label"
                id="siteArea"
                name="siteArea"
                type="text"
                labelText={`${t("site_area")}`}
                disabled={(placeSetting === "place" && action === "detail") || !isEditable}
              />
            </div>
            {/* 公司統編 */}
            <div className="col-12 lg:col-4">
              <FormInput
                register={register}
                errors={errors}
                id="taxIdNum"
                name="taxIdNum"
                labelText={`${t("taxIdNum")}`}
                rules={setValidForm("taxIdNum")}
                disabled={(placeSetting === "place" && action === "detail") || !isEditable}
              />
            </div>
            {/* 聯絡人姓名 */}
            <div className="col-12 lg:col-4">
              <Controller
                name="contactName"
                control={control}
                rules={action !== "detail" ? setValidForm("contactName") : ""}
                render={({ field, fieldState }) => (
                  <MaskedFormInput
                    {...field}
                    type="text"
                    labelClass={`form-label ${action === "detail" ? "" : "required"}`}
                    labelText={t("contact_name")}
                    maskType="name"
                    maskView={maskView}
                    setMaskView={() => handleMaskClick()}
                    disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                    errorMessage={fieldState.error?.message}
                  />
                )}
              />
            </div>
            {/* 聯絡人電子信箱 */}
            <div className="col-12 lg:col-4">
              <Controller
                name="contactEmail"
                control={control}
                rules={action !== "detail" ? setValidForm("contactEmail") : ""}
                render={({ field, fieldState }) => (
                  <MaskedFormInput
                    {...field}
                    type="email"
                    labelClass={`form-label ${action === "detail" ? "" : "required"}`}
                    labelText={t("contact_email")}
                    maskType="email"
                    maskView={maskView}
                    setMaskView={() => handleMaskClick()}
                    disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                    errorMessage={fieldState.error?.message}
                  />
                )}
              />
            </div>
            {/* 聯絡人電話 */}
            <div className="col-12 lg:col-4">
              <Controller
                name="contactTel"
                control={control}
                rules={action !== "detail" ? setValidForm("contactTel") : ""}
                render={({ field, fieldState }) => (
                  <MaskedFormInput
                    {...field}
                    type="text"
                    labelClass={`form-label ${action === "detail" ? "" : "required"}`}
                    labelText={t("contact_phone")}
                    maskType="phone"
                    maskView={maskView}
                    setMaskView={() => handleMaskClick()}
                    disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                    errorMessage={fieldState.error?.message}
                  />
                )}
              />
            </div>
            {/* 聯絡人手機 */}
            <div className="col-12 lg:col-4">
              <Controller
                name="contactMobile"
                control={control}
                rules={action !== "detail" ? setValidForm("contactMobile") : ""}
                render={({ field, fieldState }) => (
                  <MaskedFormInput
                    {...field}
                    type={action === "detail" ? "text" : "number"}
                    labelClass={`form-label ${action === "detail" ? "" : "required"}`}
                    labelText={t("contact_mobile")}
                    maskType="phone"
                    maskView={maskView}
                    setMaskView={() => handleMaskClick()}
                    disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                    errorMessage={fieldState.error?.message}
                  />
                )}
              />
            </div>
            {/* 員工人數 */}
            <div className="col-12 lg:col-4">
              <FormInput
                register={register}
                errors={errors}
                id="headcount"
                name="headcount"
                type="number"
                labelText={`${t("employees_number")}`}
                rules={setValidForm("headcount")}
                disabled={(placeSetting === "place" && action === "detail") || !isEditable}
              />
            </div>
            {/* 電號 */}
            <div className="col-12 lg:col-4">
              <FormInput
                register={register}
                errors={errors}
                id="customerNo"
                name="customerNo"
                labelText={`${t("customerNo")}`}
                rules={setValidForm("customerNo")}
                disabled={(placeSetting === "place" && action === "detail") || !isEditable}
              />
            </div>
            {/* 無電號原因 */}
            <div className="col-12 lg:col-4">
              <label
                htmlFor="customerNoMissingReason"
                className={`form-label ${!isNotBlank(watch("customerNo")) ? "required" : ""}`}
              >
                {t("customerNoMissingReason")}
              </label>
              <Controller
                name="customerNoMissingReason"
                control={control}
                rules={{
                  required: {
                    value: !isNotBlank(watch("customerNo")),
                    message: t("validation.required"),
                  },
                }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    showClear
                    disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                    appendTo={"self"}
                    optionLabel="subitemName"
                    optionValue="subitemNo"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="customerNoMissingReason"
                    control={control}
                    options={missionReasonList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                      if (event.value === "4") {
                        setValue("customerNoMissingRemark", "");
                      }
                      setTimeout(() => {
                        trigger("customerNoMissingRemark");
                      });
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, "customerNoMissingReason")}
            </div>
            <div className="col-12 lg:col-4">
              {watch("customerNoMissingReason") === "4" && (
                <>
                  <label htmlFor="customerNoMissingReason" className="form-label">
                    &nbsp;
                  </label>
                  <FormInput
                    register={register}
                    errors={errors}
                    rules={{
                      validate: (value) => {
                        if (watch("customerNoMissingReason") === "4" && !value) {
                          return t("validation.required");
                        }
                        return true;
                      },
                    }}
                    id="customerNoMissingRemark"
                    name="customerNoMissingRemark"
                    disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                  />
                </>
              )}
            </div>
            {/* 是否為共用電表 */}
            <div className="col-12 lg:col-4">
              <label htmlFor="competentAuthorityId" className="form-label">
                {t("isSharedMeter")}
              </label>
              <Controller
                name={"isSharedMeter"}
                control={control}
                render={({ field }) => (
                  <Checkbox
                    disabled={(placeSetting === "place" && action === "detail") || !isEditable}
                    checked={field.value === "Y"}
                    onChange={(e) => field.onChange(e.checked ? "Y" : "N")}
                  />
                )}
              />
            </div>
            {/* 備註 */}
            <div className="col-12">
              <FormTextarea
                register={register}
                errors={errors}
                id="remark"
                name="remark"
                labelText={`${t("remark")}`}
                rules={setValidForm("remark")}
                disabled={(placeSetting === "place" && action === "detail") || !isEditable}
              />
            </div>
            {/* 地理邊界 */}
            <div className="col-12 lg:col-6">
              <label htmlFor="areaPic" className={`form-label ${action === "detail" ? "" : "required"}`}>
                {t("geographic_boundary")}
              </label>
              <FormInputFile
                register={register}
                labelClass="required"
                errors={errors}
                id="areaPic"
                name="areaPic"
                acceptFileType=".jpg,.png"
                disabled={action === "detail" || !isEditable}
                fileChange={(e) => {
                  handleFileChange(e, "areaPic");
                }}
                fileInputRef={areaFileInputRef}
                rules={{
                  required: { value: true, message: t("validation.required") },
                }}
              />
              <ImagePDFComponent
                file={areaFileInfo?.fileInfo}
                previewUrl={areaFileInfo?.filePathSml}
                disabled={action === "detail"}
                deleteImg={() => {
                  handleDeleteImg("areaPic");
                }}
                zoomSrc={areaFileInfo?.filePath}
                wrapperClass={`${action === "detail" ? "" : "mt-3"}`}
              />
            </div>
            {/* 平面圖 */}
            <div className="col-12 lg:col-6">
              <label htmlFor="layoutPic" className="form-label">
                {t("floorPlan")}
              </label>
              <FormInputFile
                register={register}
                errors={errors}
                id="layoutPic"
                name="layoutPic"
                acceptFileType=".jpg,.png"
                disabled={action === "detail" || !isEditable}
                fileChange={(e) => {
                  handleFileChange(e, "layoutPic");
                }}
                fileInputRef={layoutFileRef}
              />
              <ImagePDFComponent
                file={layoutFileInfo?.fileInfo}
                previewUrl={layoutFileInfo?.filePathSml}
                disabled={action === "detail"}
                deleteImg={() => {
                  handleDeleteImg("layoutPic");
                }}
                zoomSrc={layoutFileInfo?.filePath}
                wrapperClass={`${action === "detail" ? "" : "mt-3"}`}
              />
            </div>

            <div className="col-12 gap-2 flex-all-center">
              {placeSetting === "addPlace" && (
                <>
                  <Button
                    disabled={!(isValid && isDirty) || !isEditable}
                    type="submit"
                    label={t("button.create")}
                    size="small"
                  />
                  <Button
                    outlined
                    type="button"
                    size="small"
                    label={t("button.cancel")}
                    onClick={(e) => {
                      clearErrors();
                      resetFormData({ companySeq: getValues("companySeq") });
                      setAction("create");
                    }}
                  />
                </>
              )}

              {placeSetting === "place" && action === "update" && (
                <>
                  <Button
                    disabled={!(isValid && isDirty) || !isEditable}
                    type="submit"
                    label={t("button.update")}
                    size="small"
                  />
                  <Button
                    outlined
                    type="button"
                    size="small"
                    label={t("button.cancel")}
                    onClick={(e) => {
                      clearErrors();
                      handlePlaceChange(getValues("place"));
                      setAction("detail");
                    }}
                  />
                </>
              )}

              {placeSetting === "place" && action === "detail" && (
                <Button
                  type="button"
                  size="small"
                  disabled={!isEditable || !getValues("companySeq") || !getValues("place")}
                  label={t("button.edit")}
                  onClick={(e) => {
                    setAction("update");
                    setMaskView(true);
                    axios_updateAuditEyesEvent();
                  }}
                />
              )}
            </div>
          </form>
        </div>
      </div>

      {/* 場所數量上限 */}
      <PrimeDialog
        visible={createLimitDialog}
        isShowConfBtn={false}
        onClose={() => {
          setCreateLimitDialog(false);
        }}
        title={t("button.create")}
        bodyTemplate={<>{t("placeLimitReached")}</>}
      />
    </>
  );
};

export default PlaceMaintain;
